export default function PolicyHint({ locked, reason, proposalMode }) {
  if (!locked && !proposalMode) return null;

  const isProposal = !!proposalMode;

  return (
    <div
      style={{
        marginTop: 6,
        fontSize: 12,
        color: isProposal ? '#0369a1' : '#92400e',
        background: isProposal ? '#e0f2fe' : '#fffbeb',
        border: isProposal ? '1px solid #bae6fd' : '1px solid #fde68a',
        borderRadius: 8,
        padding: '6px 8px',
      }}
    >
      {isProposal
        ? 'Du bist angemeldet. Änderungen an diesem geschützten Feld werden als Vorschlag gespeichert.'
        : reason || 'Dieses Feld ist geschützt. Melde dich an, um eine Änderung vorzuschlagen.'}
    </div>
  );
}
